import { environment } from '../../../environments/environment';

function resolveClientId(): string {
  const params = new URLSearchParams(window.location.search);
  const queryClientId = params.get('kcClientId');
  if (queryClientId) {
    localStorage.setItem('agora.kc.clientId', queryClientId);
    return queryClientId;
  }

  const storedClientId = localStorage.getItem('agora.kc.clientId');
  if (storedClientId) {
    return storedClientId;
  }

  return environment.defaultKeycloakClientId;
}

export const authConfig = {
  url: environment.keycloakUrl,
  realm: environment.keycloakRealm,
  clientId: resolveClientId(),
  apiBaseUrl: environment.apiBaseUrl
};
